import { ForwardedRef, forwardRef } from "react";
import { SelectInstance } from "react-select";
import { AttributeType } from "__generated__/gql/graphql";
import AttributeSelect, {
  AttributeSelectOption,
  AttributeSelectWrapperProps,
} from "components/Shared/Select/AttributeSelect";

function CompanyAttributeSelect(
  props: AttributeSelectWrapperProps,
  ref: ForwardedRef<SelectInstance<AttributeSelectOption, true>>,
) {
  return (
    <AttributeSelect
      {...props}
      ref={ref}
      attributeType={AttributeType.COMPANY}
      placeholderLabel="Select company attributes…"
      noOptionsMessageLabel="No company attributes found"
    />
  );
}

export default forwardRef(CompanyAttributeSelect);
